/**
 * Priority utility functions
 * Provides helpers for working with task priorities including colors and icons
 */

import { Priority } from '../types/todo';
import { PRIORITY } from './constants';

/**
 * Get the color associated with a priority level
 */
export function getPriorityColor(priority: Priority): string {
  return PRIORITY.COLORS[priority];
}

/**
 * Get the icon/emoji associated with a priority level
 */
export function getPriorityIcon(priority: Priority): string {
  return PRIORITY.ICONS[priority];
}
